export default "__VITE_ASSET__e62df77b__"